<template>
  <div class="card border-0 radius-bottom-0" v-if="source">
    <div class="card-header bg-dark text-white row m-0 pt-4 pb-4">
      <div class="col-11">
        <h4 class="card-tite d-flex align-items-center">
          <font-awesome-icon icon="user" class="display-4 mr-3" />

          <span class="">
            <label class="form-label">Fonte</label><br />
            {{ source.name }}
          </span>
        </h4>
      </div>

      <div class="col-1 d-flex align-items-end">
        <router-link
          v-if="$can('source:edit')"
          :to="{
            name: 'source_edit',
            params: { id: source.id }
          }"
          class="btn btn-outline-primary mr-2 link-edit"
          >Editar</router-link
        >

        <router-link
          v-else
          :to="{
            name: 'source_show',
            params: { id: source.id }
          }"
          class="btn btn-outline-primary mr-2 link-edit d-none"
          >Visualizar</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("source", ["source"])
  },
  methods: {},
  async created() {}
};
</script>
